<template>
  <div>
    <NavBar />
    <div class="mx-12 mt-8">
      <MainMenu />
      <notification-container />
      <v-row class="d-flex">
        <v-col cols="6">
          <v-card-title class="pa-0">Documentos</v-card-title>
          <v-spacer></v-spacer>
        </v-col>
      </v-row>
      
      <v-row class="d-flex">
        <v-col cols="8">
          <document-add />
        </v-col>
        <v-col cols="4">
          <v-text-field
              id="documents_page__buscar__text"
              v-model="search"
              :prepend-inner-icon="icon.search"
              label="Buscar"
              single-line
              hide-details
              clearable
              maxLength="50"
            ></v-text-field>
        </v-col>
      </v-row>
      <documents-table :search="searchDelay" :headers="documentsHeaders" />
      <signing-wizard />
    </div>
  </div>
</template>

<script>
import { mdiMagnify } from '@mdi/js'

import DocumentsTable from '../components/DocumentsTable'
import SigningWizard from '@/modules/signers/components/SigningWizard'
import DocumentAdd from '../components/DocumentAdd.vue'

export default {
  name: 'DocumentsPage',
  components: {
    DocumentAdd,
    DocumentsTable,
    SigningWizard
  },
  data() {
    return {
      icon: {
        search: mdiMagnify
      },
      search: '',
      searchDelay: '',
      eventSearch: [],
      documentsHeaders: [
      { text: 'Clave', value: 'clave', width: '110' },
      { text: 'Tipo Documento', value: 'idTipoDocumento', width: '170', order: 'tipoDocumento' },
      { text: 'Carpeta', value: 'idCarpeta', width: '160', order: 'carpeta' },
      { text: 'Nombre del documento', value: 'descripcion', width: '220', order: 'nombreDocumento' },
      { text: 'Estado', value: 'estatus', width: '90', order: 'estado' },
      { text: 'Firmantes', value: 'firmantes', sortable: false, width: '230' },
      { text: 'Creación', value: 'fechaSubidaS3', width: '120' },
      {
        text: 'Firmado',
        value: 'fechaConstancia',
        width: '90'
      },
      { text: 'Acciones', value: 'actions', sortable: false, width: '80' }
    ]
    }
  },
  watch: {
    search(v) {
      if(!v){
        this.eventSearch = []
        this.searchDelay = this.search 
      }

      this.eventSearch.push(v)
      const indexEvent = this.eventSearch.length
      let id = setTimeout(() => {
        clearTimeout(id)
        this.triggerSearch(indexEvent)
      }, 360)
    }
  },
  methods: {
    triggerSearch(indexEvent){
      if(indexEvent == this.eventSearch.length){
        this.searchDelay = this.search
      }
    }
  }
}
</script>
